import * as moment from 'moment';

export class DateTimeService {
  public parseInputDate(date): moment.Moment {
    return moment(date, 'MM-DD-YYYY');
  }

  public parseServerDate(date): moment.Moment {
    return moment(date, 'YYYY-MM-DD');
  }

  public getCurrentTime(): moment.Moment {
    return moment();
  }

  public addWeeks(date: moment.Moment, count: number): moment.Moment {
    return date.add(count, 'w');
  }

  public subtractWeeks(date: moment.Moment, count: number): moment.Moment {
    return date.subtract(count, 'w');
  }

  public humanize(date: moment.Moment): string {
    return date.format('MM/DD/YYYY');
  }

  public toInputDate(date: moment.Moment): string {
    return date.format('MM-DD-YYYY')
  }

  public isBefore(firstDate: string, secondDate: moment.Moment) {
    return this.parseServerDate(firstDate).isBefore(secondDate);
  }

  public isInTheFuture(date) {
    return moment(this.getCurrentTime()).isBefore(date);
  }

  public isValid(date) {
    return date.isValid();
  }
}
